<template>
  <!--container-->
  <div id="top">
    <div class="priceWrapper" style="margin-bottom:1rem">
      <div
        v-if="
          loading &&
            size < 20971520 &&
            item.lookingAhead !== null &&
            item.lookingAhead !== '' &&
            item.lookingAhead !== undefined
        "
        style="text-align: center;font-size: .8rem;margin-top: 2rem;"
      >
        <i class="el-icon-loading"></i>
      </div>
      <div
        v-if="show"
        :class="{ hidden: loading, none: !loading && size >= 20971520 }"
      >
        <iframe
          id="test"
          :src="
            'https://docs.google.com/gview?embedded=true&url=' +
              item.lookingAhead
          "
          class="ifme"
        ></iframe>
      </div>
      <div
        v-if="
          !loading &&
            size >= 20971520 &&
            item.lookingAhead !== null &&
            item.lookingAhead !== '' &&
            item.lookingAhead !== undefined
        "
        class="fail"
      >
        <a :href="item.lookingAhead" class="btn" target="_blank"
          >Download PDF</a
        >
      </div>
      <div v-if="item.lookingAhead == null && !loading" class="fail">
        <p>Not Uploaded Yet.</p>
      </div>
    </div>
    <reverse
      :showCall="false"
      :showReserve="
        $route.query.publicFlag &&
          $route.query.publicFlag !== undefined &&
          $route.query.publicFlag !== null
      "
      @accept="reserve"
    ></reverse>
  </div>
</template>

<script>
import reverse from "@/components/package/reserve";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      item: {},
      showReserve: true,
      pm: {},
      loading: true,
      size: 0,
      loading: true,
      timer: null,
      show: false,
      mess: new Date().getTime()
    };
  },
  created() {
    var that = this;
    this.show = false;
    if (!that.$route.params.id) {
      that.$router.push("/");
      return;
    }
    that.pm = that.$route.params;
    if (
      sessionStorage.getItem("psd") &&
      sessionStorage.getItem("psd") !== null &&
      sessionStorage.getItem("psd") !== undefined &&
      sessionStorage.getItem("psd").split("/")[1] == that.$route.params.id
    ) {
      that.getPropertyDtl2({
        params: {
          id: that.$route.params.id,
          publicFlag: this.$route.query.publicFlag ? 1 : 0,
          password: sessionStorage.getItem("psd").split("/")[0]
        },
        callback: that.callback
      });
    }
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    iframeLoaded() {
      console.log("加载完成");
      this.loading = false;
      clearInterval(this.timer);
    },
    reserve() {
      var that = this;
      that.$router.push({
        path: `/private/selection/${that.$route.params.id}?publicFlag=${that.$route.query.publicFlag}&sessionId=${that.$route.query.sessionId}`
      });
    },
    ...mapActions("property", ["getPropertyDtl", "getPdfSize"]),
    ...mapMutations("login", ["changeStatus"]),
    ...mapActions("property", ["getPropertyDtl2"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.item = res.data.data;
        that.getPdfSize({
          params: {
            pdfUrl: that.item.lookingAhead
          },
          callback: that.sizeCallback
        });
        that.show = true;
        that.$set(that.item, "lookingAhead", res.data.data.lookingAhead);
        that.$forceUpdate();
      } else if (res.data.code === 400004) {
        that.changeStatus({ data: "delete" });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    reload() {
      location.reload();
    },
    sizeCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.size = res.data.data;
        if (that.size > 20971520) {
          that.loading = false;
        } else {
          // 轮询
          this.timer = setInterval(this.longpoll, 6000);
        }
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    longpoll() {
      let test = document.getElementById("test");
      if (test.contentDocument !== null) {
        console.log("没拿到");
        document.getElementById("test").src =
          "https://docs.google.com/gview?embedded=true&url=" +
          this.item.floorPlans;
      } else {
        clearInterval(this.timer);
        console.log("拿到了");
        this.loading = false;
      }
    }
  },
  components: {
    reverse
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.show = false;
  }
};
</script>

<style lang="scss" scoped>
.hidden {
  width: 10px;
  height: 10px;
  opacity: 0;
  overflow: hidden;
}

.none {
  display: none;
}

.priceWrapper {
  padding: 2.5rem 0.24rem 0.9rem 0.24rem;
  box-sizing: border-box;
  width: 100%;

  .ifme {
    width: 100%;
    height: 70vh;
    overflow: scroll;
  }

  .fail {
    padding-top: 4rem;
    margin-bottom: 3.6rem;

    p {
      font-size: 0.28rem;
      font-family: ProximaNova-Regular, ProximaNova;
      font-weight: 400;
      color: rgba(63, 63, 70, 1);
      text-align: center;
      margin-bottom: 0.6rem;
    }

    .btn {
      display: block;
      width: 3rem;
      height: 0.92rem;
      background: rgba(44, 202, 115, 1);
      border-radius: 0.12rem;
      font-size: 0.3rem;
      color: #ffffff;
      line-height: 0.92rem;
      margin: 0 auto;
      text-align: center;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/private/looking/looking.vue